export const FETCH_APP_CONFIG = 'FETCH_APP_CONFIG'
